import moment from 'moment'
import React, {memo} from 'react'
import {useNavigate} from 'react-router-dom'
import {FavoriteButton, LikeButton, useFavoriteList} from 'entities/activity'
import {TooltipConfirmed} from 'features/tooltip-confirmed'
import {countriesMap, CountryKeys, mediaVariants} from 'shared/lib'
import {SearchUser} from 'shared/types'
import {Button} from 'shared/ui/buttons'
import {Hot} from 'shared/ui/icons'
import {ImageSliderPreview} from 'shared/ui/imageSliderPreview'
import {Tooltip} from 'shared/ui/tooltip'
import {Image} from './img/icons'
import placeholder from './img/placeholder.svg'
import styles from './styles.module.scss'

const MAX_DAY_BADGE_COUNTER = 30

export type UserCardProps = {
  containerStyles?: React.CSSProperties
  trustedUser: SearchUser & {isRemoved?: boolean}
  isFavorite?: boolean
  withChatNowBtn?: boolean
  canHideFromList?: boolean
}

export const UserCard: React.FC<UserCardProps> = memo(function UserCard({
  containerStyles,
  trustedUser,
  isFavorite,
  withChatNowBtn = true,
  canHideFromList
}) {
  const navigate = useNavigate()

  const containerHandler = () => navigate(`/profile/${trustedUser.id}`)

  const chatNowHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()

    navigate(`/messages/${trustedUser.id}`)
  }

  const images = trustedUser.photos.length
    ? trustedUser.photos.map((photo) => photo.image.url + mediaVariants.rectangle512)
    : [placeholder]

  return (
    <div className={styles.container} style={containerStyles} onClick={containerHandler}>
      <ImageSliderPreview images={images} />

      <div className={styles.info}>
        {moment().diff(trustedUser.dateCreated, 'day') <= MAX_DAY_BADGE_COUNTER ? <div className={styles.new}>NEW</div> : null}
        <div className={styles.image}>
          <Image />
          <span className={styles.count}>{trustedUser.photoCount}</span>
        </div>
      </div>
      {isFavorite
        ? <FavoriteButton
          idUser={trustedUser.id}
          wrapper={styles.likeWrapper}
          value={!trustedUser.isRemoved}
          className={styles.favoriteBtn}
          canHideFromList={canHideFromList}
        />
        : <LikeButton
          idUser={trustedUser.id}
          wrapper={styles.likeWrapper}
          value={trustedUser.isLiked}
          className={styles.like}
          activeClassName={styles.likeActive}
        />}
      <div className={styles.textContainer}>
        <div className={styles.titleWrapper}>
          <div className={`${styles.online} ${trustedUser.isOnline ? '' : styles.offline}`} />
          <p className={`${styles.name} ellipsis`}>{trustedUser.name},</p>
          <p className={styles.age}>{trustedUser.age}</p>
          {trustedUser.isConfirmed ? <TooltipConfirmed className={styles.tooltipConfirmed} /> : null}
          {
            trustedUser.isPopular ? <Tooltip title={<div className={styles.tooltipHeader}>Popular member</div>}>
              <div className={styles.iconMargin}><div className={styles.icon}><Hot /> </div></div>
            </Tooltip> : null
          }
        </div>
        <div className={`${styles.location} ellipsis`}>
          {trustedUser.country ? countriesMap[trustedUser.country as CountryKeys] : ''}
          {trustedUser.city ? `, ${trustedUser.city}` : ''}
        </div>
      </div>

      {withChatNowBtn ? <Button
        fullwidth
        styleType='primary'
        className={styles.chatNowBtn}
        onClick={chatNowHandler}
      >
        Chat now
      </Button> : null}
    </div>
  )
})